export default __webpack_public_path__ + "static/media/payment_2.0eb9c360.png";